import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, Renderer2, ElementRef, AfterViewInit, signal, inject, input, viewChild, output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CopyClipboardComponent } from "../../../modules/shared/components";

@Component({
  selector: "app-qr",
  templateUrl: "./qr.component.html",
  styleUrls: ["./qr.component.scss"],
  animations: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QRComponent implements OnInit, OnDestroy, AfterViewInit {
  private cdr = inject(ChangeDetectorRef);
  private renderer = inject(Renderer2);
  private host = inject(ElementRef);
  private translate = inject(TranslateService);

  readonly data = input<string>(undefined);

  // eslint-disable-next-line @angular-eslint/no-output-native
  readonly close = output<void>();

  animate: boolean;
  animateDestroy: any;

  readonly copyRef = viewChild<CopyClipboardComponent>("copyRef");
  // @ViewChild("focusRef") focusRef: ElementRef<HTMLInputElement>;
  readonly cardRef = viewChild("cardRef", { read: ElementRef });

  ngOnInit() {
    this.animate = true;
    this.animateDestroy = setTimeout(() => {
      this.animate = false;
      this.cdr.detectChanges();
    }, 2400);

    // this.renderer.setAttribute(this.host.nativeElement, "role", "dialog");
    // this.renderer.setAttribute(this.host.nativeElement, "aria-modal", "true");
    // this.renderer.setAttribute(this.host.nativeElement, "tabindex", "0");
    // this.renderer.setAttribute(
    //   this.host.nativeElement,
    //   "aria-label",
    //   this.translate.instant("QR code")
    // );
  }

  ngAfterViewInit(): void {
    // this.copyRef.focus();
    // this.renderer.setAttribute(this.cardRef.nativeElement, "tabindex", "0");
    this.cardRef().nativeElement.focus();
    // setTimeout(() => this.cardRef.nativeElement.focus(), 200);
    // this.cardRef.nativeElement.focus();
  }

  ngOnDestroy(): void {
    if (!!this.animateDestroy) {
      clearTimeout(this.animateDestroy);
    }
  }

  cancel() {
    this.close.emit();
  }
}
